// extracted by mini-css-extract-plugin
export var bounce = "_my-1";
export var generatingText = "_my-6";
export var lightning = "_my-4";
export var popup = "_my-5";
export var progressBar = "_my-7";
export var progressFill = "_my-8";
export var progressShimmer = "_my-9";
export var progressText = "_my-a";
export var shimmer = "_my-3";
export var uploadIcon = "_my-0";
export var uploadingText = "_my-2";